import { render, staticRenderFns } from "./CorrectScore.vue?vue&type=template&id=22f11916&scoped=true&"
import script from "./CorrectScore.vue?vue&type=script&lang=js&"
export * from "./CorrectScore.vue?vue&type=script&lang=js&"
import style0 from "./CorrectScore.vue?vue&type=style&index=0&id=22f11916&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f11916",
  null
  
)

export default component.exports